/**
 * @fileoverview gRPC-Web generated client stub for cloud
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var user_pb = require('./user_pb.js')

var account_pb = require('./account_pb.js')

var storage_pb = require('./storage_pb.js')
const proto = {};
proto.cloud = require('./service_user_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceQueryUserClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceQueryUserPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.AccountProjectRequest,
 *   !proto.cloud.AccountProjectResponse>}
 */
const methodDescriptor_ServiceQueryUser_ListAccountProjects = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryUser/ListAccountProjects',
  grpc.web.MethodType.UNARY,
  proto.cloud.AccountProjectRequest,
  proto.cloud.AccountProjectResponse,
  /**
   * @param {!proto.cloud.AccountProjectRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AccountProjectResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.AccountProjectRequest,
 *   !proto.cloud.AccountProjectResponse>}
 */
const methodInfo_ServiceQueryUser_ListAccountProjects = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.AccountProjectResponse,
  /**
   * @param {!proto.cloud.AccountProjectRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.AccountProjectResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.AccountProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.AccountProjectResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.AccountProjectResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryUserClient.prototype.listAccountProjects =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryUser/ListAccountProjects',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryUser_ListAccountProjects,
      callback);
};


/**
 * @param {!proto.cloud.AccountProjectRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.AccountProjectResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryUserPromiseClient.prototype.listAccountProjects =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryUser/ListAccountProjects',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryUser_ListAccountProjects);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.UserGetDetailedInfoRequest,
 *   !proto.cloud.UserGetDetailedInfoResponse>}
 */
const methodDescriptor_ServiceQueryUser_GetDetailedInfo = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryUser/GetDetailedInfo',
  grpc.web.MethodType.UNARY,
  proto.cloud.UserGetDetailedInfoRequest,
  proto.cloud.UserGetDetailedInfoResponse,
  /**
   * @param {!proto.cloud.UserGetDetailedInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.UserGetDetailedInfoResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.UserGetDetailedInfoRequest,
 *   !proto.cloud.UserGetDetailedInfoResponse>}
 */
const methodInfo_ServiceQueryUser_GetDetailedInfo = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.UserGetDetailedInfoResponse,
  /**
   * @param {!proto.cloud.UserGetDetailedInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.UserGetDetailedInfoResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.UserGetDetailedInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.UserGetDetailedInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.UserGetDetailedInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryUserClient.prototype.getDetailedInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryUser/GetDetailedInfo',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryUser_GetDetailedInfo,
      callback);
};


/**
 * @param {!proto.cloud.UserGetDetailedInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.UserGetDetailedInfoResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryUserPromiseClient.prototype.getDetailedInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryUser/GetDetailedInfo',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryUser_GetDetailedInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.ListAccountInvitesRequest,
 *   !proto.cloud.ListAccountInvitesResponse>}
 */
const methodDescriptor_ServiceQueryUser_ListAccountInvites = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryUser/ListAccountInvites',
  grpc.web.MethodType.UNARY,
  proto.cloud.ListAccountInvitesRequest,
  proto.cloud.ListAccountInvitesResponse,
  /**
   * @param {!proto.cloud.ListAccountInvitesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ListAccountInvitesResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.ListAccountInvitesRequest,
 *   !proto.cloud.ListAccountInvitesResponse>}
 */
const methodInfo_ServiceQueryUser_ListAccountInvites = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.ListAccountInvitesResponse,
  /**
   * @param {!proto.cloud.ListAccountInvitesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ListAccountInvitesResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.ListAccountInvitesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.ListAccountInvitesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.ListAccountInvitesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryUserClient.prototype.listAccountInvites =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryUser/ListAccountInvites',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryUser_ListAccountInvites,
      callback);
};


/**
 * @param {!proto.cloud.ListAccountInvitesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.ListAccountInvitesResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryUserPromiseClient.prototype.listAccountInvites =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryUser/ListAccountInvites',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryUser_ListAccountInvites);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.ListAllSettingsRequest,
 *   !proto.cloud.ListAllSettingsResponse>}
 */
const methodDescriptor_ServiceQueryUser_ListAllSettings = new grpc.web.MethodDescriptor(
  '/cloud.ServiceQueryUser/ListAllSettings',
  grpc.web.MethodType.UNARY,
  proto.cloud.ListAllSettingsRequest,
  proto.cloud.ListAllSettingsResponse,
  /**
   * @param {!proto.cloud.ListAllSettingsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ListAllSettingsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.ListAllSettingsRequest,
 *   !proto.cloud.ListAllSettingsResponse>}
 */
const methodInfo_ServiceQueryUser_ListAllSettings = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.ListAllSettingsResponse,
  /**
   * @param {!proto.cloud.ListAllSettingsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ListAllSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.ListAllSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.ListAllSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.ListAllSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceQueryUserClient.prototype.listAllSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceQueryUser/ListAllSettings',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryUser_ListAllSettings,
      callback);
};


/**
 * @param {!proto.cloud.ListAllSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.ListAllSettingsResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceQueryUserPromiseClient.prototype.listAllSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceQueryUser/ListAllSettings',
      request,
      metadata || {},
      methodDescriptor_ServiceQueryUser_ListAllSettings);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceVerifyUserClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceVerifyUserPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.EmailVerificationResendRequest,
 *   !proto.cloud.EmailVerificationResendResponse>}
 */
const methodDescriptor_ServiceVerifyUser_RequestResendOfVerificationEmail = new grpc.web.MethodDescriptor(
  '/cloud.ServiceVerifyUser/RequestResendOfVerificationEmail',
  grpc.web.MethodType.UNARY,
  proto.cloud.EmailVerificationResendRequest,
  proto.cloud.EmailVerificationResendResponse,
  /**
   * @param {!proto.cloud.EmailVerificationResendRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.EmailVerificationResendResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.EmailVerificationResendRequest,
 *   !proto.cloud.EmailVerificationResendResponse>}
 */
const methodInfo_ServiceVerifyUser_RequestResendOfVerificationEmail = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.EmailVerificationResendResponse,
  /**
   * @param {!proto.cloud.EmailVerificationResendRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.EmailVerificationResendResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.EmailVerificationResendRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.EmailVerificationResendResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.EmailVerificationResendResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceVerifyUserClient.prototype.requestResendOfVerificationEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceVerifyUser/RequestResendOfVerificationEmail',
      request,
      metadata || {},
      methodDescriptor_ServiceVerifyUser_RequestResendOfVerificationEmail,
      callback);
};


/**
 * @param {!proto.cloud.EmailVerificationResendRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.EmailVerificationResendResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceVerifyUserPromiseClient.prototype.requestResendOfVerificationEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceVerifyUser/RequestResendOfVerificationEmail',
      request,
      metadata || {},
      methodDescriptor_ServiceVerifyUser_RequestResendOfVerificationEmail);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceUpdateUserClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.cloud.ServiceUpdateUserPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.UserUpdateDetailedInfoRequest,
 *   !proto.cloud.UserUpdateDetailedInfoResponse>}
 */
const methodDescriptor_ServiceUpdateUser_UpdateDetailedInfo = new grpc.web.MethodDescriptor(
  '/cloud.ServiceUpdateUser/UpdateDetailedInfo',
  grpc.web.MethodType.UNARY,
  proto.cloud.UserUpdateDetailedInfoRequest,
  proto.cloud.UserUpdateDetailedInfoResponse,
  /**
   * @param {!proto.cloud.UserUpdateDetailedInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.UserUpdateDetailedInfoResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.UserUpdateDetailedInfoRequest,
 *   !proto.cloud.UserUpdateDetailedInfoResponse>}
 */
const methodInfo_ServiceUpdateUser_UpdateDetailedInfo = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.UserUpdateDetailedInfoResponse,
  /**
   * @param {!proto.cloud.UserUpdateDetailedInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.UserUpdateDetailedInfoResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.UserUpdateDetailedInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.UserUpdateDetailedInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.UserUpdateDetailedInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceUpdateUserClient.prototype.updateDetailedInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceUpdateUser/UpdateDetailedInfo',
      request,
      metadata || {},
      methodDescriptor_ServiceUpdateUser_UpdateDetailedInfo,
      callback);
};


/**
 * @param {!proto.cloud.UserUpdateDetailedInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.UserUpdateDetailedInfoResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceUpdateUserPromiseClient.prototype.updateDetailedInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceUpdateUser/UpdateDetailedInfo',
      request,
      metadata || {},
      methodDescriptor_ServiceUpdateUser_UpdateDetailedInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.ProfileImageUploadRequest,
 *   !proto.cloud.ProfileImageUploadResponse>}
 */
const methodDescriptor_ServiceUpdateUser_GetProfileImageUpload = new grpc.web.MethodDescriptor(
  '/cloud.ServiceUpdateUser/GetProfileImageUpload',
  grpc.web.MethodType.UNARY,
  proto.cloud.ProfileImageUploadRequest,
  proto.cloud.ProfileImageUploadResponse,
  /**
   * @param {!proto.cloud.ProfileImageUploadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ProfileImageUploadResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.ProfileImageUploadRequest,
 *   !proto.cloud.ProfileImageUploadResponse>}
 */
const methodInfo_ServiceUpdateUser_GetProfileImageUpload = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.ProfileImageUploadResponse,
  /**
   * @param {!proto.cloud.ProfileImageUploadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.ProfileImageUploadResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.ProfileImageUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.ProfileImageUploadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.ProfileImageUploadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceUpdateUserClient.prototype.getProfileImageUpload =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceUpdateUser/GetProfileImageUpload',
      request,
      metadata || {},
      methodDescriptor_ServiceUpdateUser_GetProfileImageUpload,
      callback);
};


/**
 * @param {!proto.cloud.ProfileImageUploadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.ProfileImageUploadResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceUpdateUserPromiseClient.prototype.getProfileImageUpload =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceUpdateUser/GetProfileImageUpload',
      request,
      metadata || {},
      methodDescriptor_ServiceUpdateUser_GetProfileImageUpload);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.UserInviteResolutionRequest,
 *   !proto.cloud.UserInviteResolutionResponse>}
 */
const methodDescriptor_ServiceUpdateUser_ResolveUserInvite = new grpc.web.MethodDescriptor(
  '/cloud.ServiceUpdateUser/ResolveUserInvite',
  grpc.web.MethodType.UNARY,
  proto.cloud.UserInviteResolutionRequest,
  proto.cloud.UserInviteResolutionResponse,
  /**
   * @param {!proto.cloud.UserInviteResolutionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.UserInviteResolutionResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.UserInviteResolutionRequest,
 *   !proto.cloud.UserInviteResolutionResponse>}
 */
const methodInfo_ServiceUpdateUser_ResolveUserInvite = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.UserInviteResolutionResponse,
  /**
   * @param {!proto.cloud.UserInviteResolutionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.UserInviteResolutionResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.UserInviteResolutionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.UserInviteResolutionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.UserInviteResolutionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceUpdateUserClient.prototype.resolveUserInvite =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceUpdateUser/ResolveUserInvite',
      request,
      metadata || {},
      methodDescriptor_ServiceUpdateUser_ResolveUserInvite,
      callback);
};


/**
 * @param {!proto.cloud.UserInviteResolutionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.UserInviteResolutionResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceUpdateUserPromiseClient.prototype.resolveUserInvite =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceUpdateUser/ResolveUserInvite',
      request,
      metadata || {},
      methodDescriptor_ServiceUpdateUser_ResolveUserInvite);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.cloud.UserUpdateSettingsRequest,
 *   !proto.cloud.UserUpdateSettingsResponse>}
 */
const methodDescriptor_ServiceUpdateUser_UpdateUserAccountSettings = new grpc.web.MethodDescriptor(
  '/cloud.ServiceUpdateUser/UpdateUserAccountSettings',
  grpc.web.MethodType.UNARY,
  proto.cloud.UserUpdateSettingsRequest,
  proto.cloud.UserUpdateSettingsResponse,
  /**
   * @param {!proto.cloud.UserUpdateSettingsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.UserUpdateSettingsResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.cloud.UserUpdateSettingsRequest,
 *   !proto.cloud.UserUpdateSettingsResponse>}
 */
const methodInfo_ServiceUpdateUser_UpdateUserAccountSettings = new grpc.web.AbstractClientBase.MethodInfo(
  proto.cloud.UserUpdateSettingsResponse,
  /**
   * @param {!proto.cloud.UserUpdateSettingsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.cloud.UserUpdateSettingsResponse.deserializeBinary
);


/**
 * @param {!proto.cloud.UserUpdateSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.cloud.UserUpdateSettingsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.cloud.UserUpdateSettingsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.cloud.ServiceUpdateUserClient.prototype.updateUserAccountSettings =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/cloud.ServiceUpdateUser/UpdateUserAccountSettings',
      request,
      metadata || {},
      methodDescriptor_ServiceUpdateUser_UpdateUserAccountSettings,
      callback);
};


/**
 * @param {!proto.cloud.UserUpdateSettingsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.cloud.UserUpdateSettingsResponse>}
 *     A native promise that resolves to the response
 */
proto.cloud.ServiceUpdateUserPromiseClient.prototype.updateUserAccountSettings =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/cloud.ServiceUpdateUser/UpdateUserAccountSettings',
      request,
      metadata || {},
      methodDescriptor_ServiceUpdateUser_UpdateUserAccountSettings);
};


module.exports = proto.cloud;

